import { render, staticRenderFns } from "./myNewOrder.vue?vue&type=template&id=3a11596d&scoped=true&"
import script from "./myNewOrder.vue?vue&type=script&lang=js&"
export * from "./myNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./myNewOrder.vue?vue&type=style&index=0&id=3a11596d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a11596d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VFooter,VRow,VSelect,VTextField})
